import React from 'react';
import { PlanSelector } from '../ui/PlanSelector';
export const FinalCta = () => {
  return <section className="py-16 md:py-20 px-5 text-center relative overflow-hidden" data-id="element-106">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[70%] h-[60%] bg-cyan/5 rounded-full blur-[100px] -z-10 pointer-events-none" data-id="element-107"></div>

      <div className="max-w-[860px] mx-auto" data-id="element-108">
        <p className="text-xs tracking-[0.1em] uppercase text-cyan mb-3 font-semibold" data-id="element-109">
          No dejes pasar esta oportunidad
        </p>
        <h2 className="text-[clamp(26px,4vw,36px)] font-extrabold leading-[1.2] mb-3" data-id="element-110">
          Tu sistema de enseñanza empieza hoy
        </h2>
        <p className="text-[15px] md:text-[16px] text-[#aaa] max-w-[560px] mx-auto mb-8" data-id="element-111">
          Más de 500 profesores ya tienen el Kit. Empezá a transformar tus
          clases hoy mismo.
        </p>

        <PlanSelector variant="compact" data-id="element-112" />

        <p className="mt-5 text-[12px] text-[#666]" data-id="element-113">
          Pago seguro · Mercado Pago · Garantía 7 días
        </p>
      </div>
    </section>;
};